"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var getFileUrl = function (image) {
    return image ? "".concat((0, constants_1.getUrl)(), "/").concat(image) : null;
};
exports.default = getFileUrl;
